<script>
  import { Router, Route } from 'svelte-routing';
  import Home from '../../components/WebSite/Home.svelte';
  import Products from '../../pages/products/index.svelte';
  import SignUp from '../../components/WebSite/SignUp.svelte';

  export let url = '';

  

</script>

<Router {url}>
  
    <Route path="products/:id" let:params>
      <Products id="{params.id}"/>
    </Route>
    <Route path="/">
      <Home/>
    </Route>
    <Route path="/signUp"><SignUp/> </Route>

</Router>


<style >
  

</style>